/**
 * 購入サービスの縦並び正準順（GBなび → GB人財 → GB組織）。
 *
 * プラン選択・確認・支払い・完了の各画面で、サービスを縦に並べる際の表示順を
 * この順に統一する。バックエンド（メール本文・MF請求明細）にも同一順の実装がある
 * （apps/web/backend .../purchase/serviceOrder.ts）。
 */
export const SERVICE_ORDER = ['GB_NAVI', 'GB_JINZAI', 'GB_SOSHIKI'] as const;

/** product code を正準順にランク付け（未知 code は末尾）。 */
function serviceRank(code: string): number {
  const i = SERVICE_ORDER.indexOf(code as (typeof SERVICE_ORDER)[number]);
  return i === -1 ? SERVICE_ORDER.length : i;
}

/**
 * 配列を product code で正準順（GBなび→GB人財→GB組織）にソートした新配列を返す。
 * @param codeOf 各要素から product code を取り出す関数
 */
export function sortByServiceOrder<T>(items: T[], codeOf: (item: T) => string): T[] {
  return [...items].sort((a, b) => serviceRank(codeOf(a)) - serviceRank(codeOf(b)));
}
